import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        company: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'company.General company information' | translate}}</h1>
        </div>
        <div class="person01">
            <!--<div class="img todo">-->
                <!--<a class="btn secondary" href="#">{{ 'company.Add logo' | translate}}</a>-->
            <!--</div>-->
            <div class="txt">
                <form class="form" ng-submit="vm.save()">
                    <form-wrapper form="vm.form">
                        <div class="row">
                            <label class="label">{{ 'company.Company name' | translate}}</label>
                            <div class="items">
                                <input ng-model="vm.form.model.name" type="text" class="form-control" readonly>
                            </div>
                        </div>
                        <form-row error="vm.form.errors.certFile">
                            <label class="label">{{ 'company.Choose certificate image' | translate}}</label>
                            <div class="items">
                                <input ngf-select="vm.setCertFile($file)" type="file" />
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <div class="row" ng-if="vm.form.model.certificateFilename">
                            <label class="label">{{ 'company.Certificate image' | translate}}</label>
                            <div class="items">
                                <div class="form-img">
                                    <img ng-src="{{ vm.CompanyService.getCertificateImage(vm.form.model.certificateFilename, vm.company.id) }}">
                                    <ul class="actions01">
                                        <li><a class="btn delete" ng-click="vm.deleteCertImage()">{{ 'general.Remove' | translate }}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <form-row error="vm.form.errors.logoFile">
                            <label class="label">{{ 'company.Choose logo image' | translate}}</label>
                            <div class="items">
                                <input ngf-select="vm.setLogoFile($file)" type="file" />
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <div class="row" ng-if="vm.form.model.logoFilename">
                            <label class="label">{{ 'company.Logo' | translate}}</label>
                            <div class="items">
                                <div class="form-img">
                                    <img ng-src="{{ vm.CompanyService.getLogoImage(vm.form.model.logoFilename, vm.company.id, 'companySettings') }}">
                                    <ul class="actions01">
                                        <li><a class="btn delete" ng-click="vm.deleteLogoImage()">{{ 'general.Remove' | translate }}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row" ng-if="vm.TokenService.isExternalParticipationModuleEnabled()">
                            <span class="label">{{ 'company.Allow direct managers to manage external participations' | translate }}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" name="switch" ng-model="vm.form.model.isExternalParticipationDmApprovementEnabled">
                                    <span>Yes</span>
                                </label>
                            </div>
                        </div>
                        <div class="row row-indented" ng-if="vm.form.model.isExternalParticipationDmApprovementEnabled">
                            <span class="label">{{ 'company.Notify admin account when direct manager confirms application' | translate }}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" checked name="switch2" ng-model="vm.form.model.isExternalParticipationDmApprovementNotificationsEnabled">
                                    <span>Yes</span>
                                </label>
                            </div>
                        </div>
                        <div class="row row-indented" ng-if="vm.form.model.isExternalParticipationDmApprovementEnabled && vm.form.model.isExternalParticipationDmApprovementNotificationsEnabled">
                            <label class="label">{{ 'company.E-mail address for notification' | translate }} *</label>
                            <div class="items">
                                <input type="text" class="form-control" ng-model="vm.form.model.externalParticipationTemplate.recipientEmail">
                            </div>
                        </div>
                        <div class="row row-indented row-full"
                            ng-if="vm.form.model.isExternalParticipationDmApprovementEnabled && vm.form.model.isExternalParticipationDmApprovementNotificationsEnabled">
                            <label class="label">{{ 'company.E-mail content' | translate }}</label>
                            <div class="items">
                                <div>
                                    <div>
                                        <form-row error="vm.form.errors.externalParticipationTemplate">
                                            <form-row-error></form-row-error>
                                        </form-row>
                                    </div>
                                    <div class="colholder mt1em">
                                        <div class="col01">
                                            <div class="row row-wide">
                                                <label class="label w100p">{{ 'company.Subject' | translate }} *</label>
                                                <div class="items w100p">
                                                    <input type="text" class="form-control wide" ng-model="vm.form.model.externalParticipationTemplate.activeI18n.msgSubject">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col01"></div>
                                    </div>
                                    <div class="colholder mt1em">
                                        <div class="col01">
                                            <div class="row row-wide">
                                                <label class="label w100p">{{ 'company.Content' | translate }} *</label>
                                                <div class="items w100p">
                                                    <ng-ckeditor ng-model="vm.form.model.externalParticipationTemplate.activeI18n.msgBody" ng-config="vm.ckconfig"></ng-ckeditor>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col01">
                                            <div class="alert alert-plain mt30">
                                                <p>{{ 'company.You can use the following variables in email and notification' | translate }}:</p>
                                                <ul>
                                                    <li ng-repeat="item in vm.getVariables(vm.form.model.externalParticipationTemplate)">{{ vm.getTag(item) }}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <span class="label">{{ 'company.Hide personal code from non-admin users' | translate}}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" name="switch" ng-model="vm.form.model.hidePersonalData">
                                    <span>Yes</span>
                                </label>
                            </div>
                        </div>
                    </form-wrapper>
                </form>
            </div>
        </div>
        <ul class="actions01">
            <li>
                <a ui-sref="authorized.manage.settings.general()" ng-click="vm.save()" class="btn main">{{ 'general.Save' | translate}}</a>
            </li>
        </ul>
    `
})
export default class {
    constructor ($translate, lodash, toastr, FormFactory, Upload, CompanyService, ModalService, TokenService, NotificationResource, CkEditorService) {
        this.TokenService = TokenService;
        this.FormFactory = FormFactory;
        this.$translate = $translate;
        this.lodash = lodash;
        this.Upload = Upload;
        this.toastr = toastr;
        this.CompanyService = CompanyService;
        this.ModalService = ModalService;
        this.NotificationResource = NotificationResource;
        this.CkEditorService = CkEditorService;

        this.initForm();
        this.languages = this.form.model.languages;
        this.loadExternalParticipationTemplate();

        this.ckconfig = this.CkEditorService.getNotificationConfig();
    }

    initForm () {
        this.form = this.FormFactory.create(this.company, model => model.$update({ id: model.id, expand: 'languages' }));
        if (this.form.model.hidePersonalData) {
            this.form.model.hidePersonalData = true;
        }
    }

    getTag (variable) {
        return `{{ ${variable} }}`;
    }

    getVariables (template) {
        if (template) {
            return Object.getOwnPropertyNames(template.activeI18n.variablesJson);
        }
        return '';
    }

    setCertFile (file) {
        this.form.model.certFile = file;
    }

    setLogoFile (file) {
        this.form.model.logoFile = file;
    }

    beforeSave () {
        this.form.model.languages = this.form.model.languages.map(language => language.language);
    }

    save () {
        this.beforeSave();

        const uploadUrl = `${SEED_CORE.ENV.API_URL}company/company/${this.company.id}`;
        // upload can not have any circular references
        delete this.form.model.$promise;
        delete this.form.model.$resolved;

        this.Upload.upload({
            url: uploadUrl,
            method: 'PUT',
            data: this.form.model
        })
        .then((response) => {
            this.company = response.data;
            this.toastr.success(this.$translate.instant('general.Changes saved'));
            this.form.model.languages = this.languages;
        }).catch((response) => {
            this.form.invalid = true;
            this.form.saved = false;
            this.form.errors = this.parseErrors(response);
            this.form.model.languages = this.languages;
            this.toastr.error(response.data[0].message);
        });
    }

    loadExternalParticipationTemplate () {
        this.NotificationResource.templateIndex({ messageClass: 'AdminConfirmationFromDirectManagerMessage', onlyVisible: false, expand: 'activeI18n' })
        .$promise.then(templates => {
            this.form.model.externalParticipationTemplate = templates[0];
        });
    }

    deleteCertImage () {
        const message = this.$translate.instant('company.Are you sure you want to delete the image?');
        this.ModalService.confirm(message, 'small').then(() => {
            this.form.model.deleteCertImage = true;
            this.save();
        });
    }

    deleteLogoImage () {
        const message = this.$translate.instant('company.Are you sure you want to delete the image?');
        this.ModalService.confirm(message, 'small').then(() => {
            this.form.model.deleteLogoImage = true;
            this.save();
        });
    }

    parseErrors (response) {
        return response.data.reduce((original, error) => {
            if (error.path) {
                this.lodash.set(original, `${error.path}.${error.field}`, error.message);
            }
            else {
                original[error.field] = error.message;
            }
            return original;
        }, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/general/index.js